// Shared dashboard form styling constants promoted from the Members workflow
// (memberWorkflowShared.tsx) and Chamber Settings (settingsStyles.ts) donors.
// Pure constants only — no components live in this file.
import { commonStyles } from "../commonStyles";

export const cpaGold = commonStyles.cpaGold;
export const cpaGoldDark = commonStyles.cpaGoldDark;

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "white",
    borderRadius: "6px",
    "& fieldset": {
      borderColor: "#8F969E",
    },
    "&:hover fieldset": {
      borderColor: "#6B7280",
    },
    "&.Mui-focused fieldset": {
      borderWidth: 1,
      borderColor: cpaGold,
    },
  },
  "& .MuiInputBase-input": {
    fontSize: 15,
  },
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
  },
};

// Manage Your Chamber donor: dark 1px outline, 8px corners, and 16px copy.
// Kept additive so existing dashboard forms retain their established skin.
export const adminChamberFieldSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "white",
    borderRadius: "8px",
    "& fieldset": {
      borderColor: "rgba(0, 0, 0, 0.87)",
      borderRadius: "8px",
    },
    "&:hover fieldset": {
      borderColor: "rgba(0, 0, 0, 0.87)",
    },
    "&.Mui-focused fieldset": {
      borderWidth: 1,
      borderColor: cpaGold,
    },
    "&.Mui-error fieldset": {
      borderColor: commonStyles.errorRed,
    },
  },
  "& .MuiInputBase-input": {
    color: "#333333",
    fontSize: 16,
  },
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
  },
};

export const choiceControlLabelSx = {
  alignItems: "flex-start",
  margin: 0,
  "& .MuiFormControlLabel-label": {
    minWidth: 0,
    lineHeight: 1.5,
    paddingTop: "9px",
  },
};

// Checkbox and radio layout only: their look comes from cmpTheme (Monday
// 13396402468).
export const checkboxControlSx = {
  paddingTop: "6px",
};

export const radioControlSx = {
  paddingTop: "6px",
};

// A checkbox or radio that replaces a native input beside its label: no
// padding, so the 18px box sits where the native box was.
export const inlineChoiceControlSx = {
  flexShrink: 0,
  padding: 0,
};

// Selected-value chips across the member forms match the mock's category
// chips: rounded chip with a red circular "x" remover (MEM-CREATE-023).
export const selectionChipSx = {
  "& .MuiChip-deleteIcon": {
    color: "#DC2626",
    "&:hover": { color: "#B91C1C" },
  },
};

// Step-footer buttons of the member wizard (white-outlined Previous/Cancel and
// gold contained Next/Create). Layout-only keys (minWidth, justifyContent,
// textAlign) vary per call site and stay inline there — spread these constants
// and add the layout keys locally.
export const wizardOutlinedButtonSx = {
  borderColor: "#D1D5DB",
  color: "#111827",
  fontWeight: 700,
  textTransform: "none",
  "&:hover": {
    borderColor: "#9CA3AF",
    backgroundColor: "rgba(17, 24, 39, 0.04)",
  },
};

export const wizardGoldButtonSx = {
  backgroundColor: cpaGold,
  color: "white",
  fontWeight: 800,
  textTransform: "none",
  "&:hover": { backgroundColor: cpaGoldDark },
};

// Moved verbatim from ChamberSettings settingsStyles.ts (settingsInputClassName);
// settingsStyles.ts re-exports it under the original name.
export const dashboardInputClassName =
  "h-11 rounded-lg border border-[#DCE4F0] bg-white px-3 text-sm text-gray-900 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-cpaGold focus:ring-2 focus:ring-amber-100 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-500";
